import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const MESSAGES = [
  "Scanning fabric weave…",
  "Reading brand tag metadata…",
  "Fetching eBay & Depop comps…",
  "Cross-referencing 12,400 sold listings…",
  "Calculating net margins…",
  "Composing platform-native listings…",
];

export default function ScanningOverlay({ active }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!active) return;
    setI(0);
    const id = setInterval(() => setI((x) => (x + 1) % MESSAGES.length), 900);
    return () => clearInterval(id);
  }, [active]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          data-testid="scanning-overlay"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          className="glass px-5 py-4 flex items-center gap-3"
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          >
            <Sparkles size={18} className="text-[#7C3AED]" />
          </motion.div>
          <div className="flex-1 relative h-5 overflow-hidden">
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -20, opacity: 0 }}
                transition={{ duration: 0.35 }}
                className="absolute inset-0 text-sm text-white font-mono-num"
              >
                {MESSAGES[i]}
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="w-16 h-1 rounded-full bg-white/10 overflow-hidden">
            <motion.div
              className="h-full bg-gradient-to-r from-[#7C3AED] to-[#10B981]"
              initial={{ width: "10%" }}
              animate={{ width: ["10%", "90%", "40%", "95%"] }}
              transition={{ duration: 4, repeat: Infinity }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
